import { Field } from 'formik';
import classNames from 'classnames';
import { InputCheckboxSettingsShape } from '@rabbit/elements/shared-types';

export interface InputCheckboxProps {
  name: string;
  settings: InputCheckboxSettingsShape; //any to remove
}

const dynamicStyles = {
  base: 'text-primary-900 focus:ring-transparent h-4 w-4 rounded border-gray-300 bg-gray-50',
  disabled: 'border-gray-300 text-gray-400 opacity-60 cursor-not-allowed',
};

export function InputCheckbox({ name, settings }: InputCheckboxProps) {
  const { checkboxLabel, checkboxLabelStyles, onChange, asBoolean, checked, value, ...rest } =
    settings;

  return (
    <label className="flex items-center gap-2 leading-[1.2rem]">
      <Field name={name}>
        {({ field, form }: any) => (
          <input
            className={classNames(dynamicStyles.base, {
              [`${dynamicStyles.disabled}`]: rest.disabled,
            })}
            type="checkbox"
            name={name}
            checked={checked !== undefined ? checked : field.value}
            onChange={(e) => {
              // Update Formik field value
              form.setFieldValue(name, e.target.checked);
              
              // Call custom onChange if provided
              if (onChange) {
                if (asBoolean) {
                  onChange(e.target.checked);
                } else if (checkboxLabel) {
                  onChange(checkboxLabel);
                } else {
                  onChange(e.target.checked);
                }
              }
            }}
            {...rest}
          />
        )}
      </Field>
      {checkboxLabel && (
        <span
          className={classNames(checkboxLabelStyles, {
            [`${dynamicStyles.disabled}`]: rest.disabled,
          })}
          dangerouslySetInnerHTML={{
            __html: checkboxLabel,
          }}
        ></span>
      )}
    </label>
  );
}

export default InputCheckbox;
